import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ssw/downloads/downloads-banner.webp'


const _withScopeId = n => (_pushScopeId("data-v-07d792cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"downloads_banner p-0\" data-v-07d792cc><div class=\"banner_slider_wrapper\" data-v-07d792cc><div class=\"box\" data-v-07d792cc><div class=\"container wrapper\" data-v-07d792cc><div class=\"text opacity-1\" data-v-07d792cc><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-07d792cc> DOWNLOADS </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"Stamford Sports Wheels (SSW) Image\" data-v-07d792cc></div></div></section>", 1)
const _hoisted_2 = { class: "downloads" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row justify-content-center list" }
const _hoisted_6 = ["href"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadsList, (row, index) => {
              return (_openBlock(), _createElementBlock("ul", {
                class: "col-12 d-flex",
                key: row.id
              }, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: row.url,
                    target: "_blank"
                  }, _toDisplayString(row.title), 9, _hoisted_6)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}